export const tileSize = {
  DEFAULT: "DEFAULT",
  LARGE: "LARGE",
  SMALL: "SMALL",
  EXTRA_SMALL: "EXTRA_SMALL",
};
